import { render, staticRenderFns } from "./ConsultaJurisprudenciaSelecionada.vue?vue&type=template&id=9f1a3404"
import script from "./ConsultaJurisprudenciaSelecionada.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConsultaJurisprudenciaSelecionada.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports